import React, { useEffect, useState } from 'react'
import { useRecoilState } from 'recoil'
import { Link } from 'gatsby'
import { Container, Col, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhone, faVrCardboard, faBars, faXmark } from '@fortawesome/free-solid-svg-icons'
import { useScrollPosition } from '@n8tb1t/use-scroll-position'
import HeaderSlogan from './HeaderSlogan'
import { Button, Logo } from '../common'
import HeaderMenu from './HeaderMenu'
import { mobileMenuState } from '../navigation/menuState'
import TopMenu from '../navigation/TopMenu'
import HeaderProductSearch from '../search/HeaderProductSearch'
import SocialList from '../social/SocialList'
import HeaderCart from './HeaderCart'

export default ({ elementRef }) => {
  const [mobileMenu, setMobileMenu] = useRecoilState(mobileMenuState)
  const [lockHeader, setLockHeader] = useState(false)

  useEffect(() => {
    return () => setMobileMenu(false)
  }, [])

  useScrollPosition(({ prevPos, currPos }) => {
    // Have we passed the element yet?
    if (currPos.y <= -127) {
     setLockHeader(true)
    }
    else {
      setLockHeader(false)
    }
  }, [], elementRef)

  const headerClasses = []
  if (lockHeader) {
    headerClasses.push('header-locked')
  }

  return (
    <header className={headerClasses.join(' ')}>
      <div className="header-top">
        <Container fluid="xxl">
          <Row className="d-flex align-items-center">
            <Col xs={12} md={6} className="d-flex justify-content-start slogan-col">
              <HeaderSlogan />
            </Col>
            <Col xs={12} md={6} className="d-flex justify-content-end top-menu-col">
              <div className="top-menu-container">
                <ul className="menu">
                  <li>
                    <a target="_blank" href="https://vr.metalcorpsteel.com.au">
                      <FontAwesomeIcon icon={faVrCardboard} />
                      Virtual yard
                    </a>
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="header">
        <Container fluid="xxl">
          <Row className="header-row">
            <Col xs={12} md={3} className="d-flex align-items-center justify-content-center header-left-col">
              <Link to="/">
                <Logo />
              </Link>
            </Col>
            <Col xs={12} md={9} className="header-right-col">
              <Row className="d-flex align-items-center header-right-col-row-top">
                <Col xs={12} sm={6} className="p-3 d-flex justify-content-start">
                  <TopMenu />
                </Col>
                <Col xs={12} sm={6} className="p-3 d-flex justify-content-end">
                  <SocialList />
                </Col>
              </Row>
              <Row className="d-flex align-items-center header-left-row-top">
                <Col xs={3} sm={2} lg={2} md={4} className="mobile-menu-col">
                  <MobileMenuButton display={mobileMenu} setDisplay={setMobileMenu} />
                </Col>
                <Col xs={9} sm={10} md={8} lg={7} xl={8} className="product-search-col">
                  <HeaderProductSearch />
                </Col>
                <Col md={3} lg={3} xl={2} className="phone-col">
                  <h5 className="m-0">
                    <a className="phone-link" href="tel:1300306204">
                      <FontAwesomeIcon icon={faPhone} />1300 306 204
                    </a>
                  </h5>
                </Col>
                <Col xs={2} sm={4} lg={2} md={4} className="cart-col">
                  <HeaderCart />
                </Col>
              </Row>
            </Col>
          </Row>
          <HeaderMenu mobileMenu={mobileMenu} />
        </Container>
      </div>
    </header>
  )
}

const MobileMenuButton = ({ display, setDisplay }) => {
  const onClickHandler = () => {
    setDisplay((prev) => !prev)
  }

  return (
    <Button onClick={() => onClickHandler()}>
      {display ? 
        <FontAwesomeIcon icon={faXmark} /> 
      : 
        <FontAwesomeIcon icon={faBars} />
      }
    </Button>
  )
}